import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ExecutorDashboardComponent } from './executor-dashboard.component';

import { UserProfileComponent } from './../components/user-profile/user-profile.component';
import { ProgressTrackerComponent } from './../components/progress-tracker/progress-tracker.component';
import { RequestUserAccessComponent } from '../components/request-user-access/request-user-access.component';
import { AssessmentComponent } from '../components/assessment/assessment.component';
import { HistoricalAssessmentComponent } from '../components/historical-assessment/historical-assessment.component';
import { ResubmitClarifyComponent } from '../components/resubmit-clarify/resubmit-clarify.component';
import { RiskRatingComponent } from '../components/risk-rating/risk-rating.component';
import { ReportIssueComponent } from '../components/report-issue/report-issue.component';
import { CasesComponent } from '../components/cases/cases.component';
import { ReportingComponent } from '../components/reporting/reporting.component';
import { ReviewComponent } from '../components/review/review.component';
import { ResubmitCheckerComponent } from '../components/resubmit-checker/resubmit-checker.component';
import { ActionItemsComponent } from '../components/action-items/action-items.component';
import { ProgressDetailChartComponent } from '../components/progress-detail-chart/progress-detail-chart.component';
import { ResourcesComponent } from '../components/resources/resources.component';
import { HistoricalActionItemsComponent } from '../components/historical-action-items/historical-action-items.component';
import { PendingActionItemsComponent } from '../components/pending-action-items/pending-action-items.component';
import { RejectedActionItemsComponent } from '../components/rejected-action-items/rejected-action-items.component';
import { ActionItemDetailComponent } from '../components/action-item-detail/action-item-detail.component';

import { EnforcementSelectComponent } from '../components/enforcement-select/enforcement-select.component';
import { EnforcementHistoricalComponent } from '../components/enforcement-historical/enforcement-historical.component';
import { EnforcementDetailComponent } from '../components/enforcement-detail/enforcement-detail.component';
import { FinesSelectComponent } from '../components/fines-select/fines-select.component';
import { FinesHistoricalComponent } from '../components/fines-historical/fines-historical.component';
import { FinesDetailComponent } from '../components/fines-detail/fines-detail.component';
import { AppealSelectComponent } from '../components/appeal-select/appeal-select.component';
import { AppealHistoricalComponent } from '../components/appeal-historical/appeal-historical.component';
import { AppealDetailComponent } from '../components/appeal-detail/appeal-detail.component';

const routes: Routes = [
  {
    path: '',
    component: ExecutorDashboardComponent,
    children: [
      { path: 'request-user-access', component: RequestUserAccessComponent },
      { path: 'assessment', component: AssessmentComponent },
      { path: 'progress-tracker', component: ProgressTrackerComponent },
      { path: 'progress-tracker-details', component: ProgressDetailChartComponent },
      { path: 'historical-assesment', component: HistoricalAssessmentComponent },
      { path: 'resubmit-clarify', component: ResubmitClarifyComponent },
      { path: 'risk-rating', component: RiskRatingComponent },
      { path: 'user-profile', component: UserProfileComponent },
      { path: 'report-issue', component: ReportIssueComponent },
      { path: 'cases', component: CasesComponent },
      { path: 'resources', component: ResourcesComponent },
      { path: 'reports', component: ReportingComponent },
      { path: 'action-items/rejected', component: RejectedActionItemsComponent },
      { path: 'action-items/pending', component: PendingActionItemsComponent },
      { path: 'action-items/historical', component: HistoricalActionItemsComponent },
      { path: 'action-items/:category/details', component: ActionItemDetailComponent },
      { path: 'monitoring/review', component: ReviewComponent },
      { path: 'monitoring/resubmit', component: ResubmitCheckerComponent },
            { path: 'enforcement/active', component: EnforcementSelectComponent },
      { path: 'enforcement/historical', component: EnforcementHistoricalComponent },
      { path: 'enforcement/detail', component: EnforcementDetailComponent },
      { path: 'fines/active', component: FinesSelectComponent },
      { path: 'fines/historical', component: FinesHistoricalComponent },
      { path: 'fines/detail', component: FinesDetailComponent },
      { path: 'appeal/initiate', component: AppealSelectComponent },
      { path: 'appeal/historical', component: AppealHistoricalComponent },
      { path: 'appeal/detail', component: AppealDetailComponent }
      // { path: '', redirectTo: 'assessment', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ExecutorDashboardRoutingModule { }
